"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = exports.ALIGNMENT_DATA_KEY = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _draftJs = require("draft-js"),
    _getCurrentlySelectedBlock = _interopRequireDefault(require("../utils/getCurrentlySelectedBlock")),
    ALIGNMENT_DATA_KEY = "textAlignment";

exports.ALIGNMENT_DATA_KEY = ALIGNMENT_DATA_KEY;
var ExtendedRichUtils = Object.assign({}, _draftJs.RichUtils, {
  toggleAlignment: function toggleAlignment(editorState, alignment) {
    var _getCurrentlySelected = (0, _getCurrentlySelectedBlock["default"])(editorState),
        content = _getCurrentlySelected.content,
        currentBlock = _getCurrentlySelected.currentBlock,
        hasAtomicBlock = _getCurrentlySelected.hasAtomicBlock,
        target = _getCurrentlySelected.target;

    if (hasAtomicBlock) return editorState;
    var blockData = currentBlock.getData(),
        alignmentToSet = blockData && blockData.get(ALIGNMENT_DATA_KEY) === alignment ? void 0 : alignment;
    return _draftJs.EditorState.push(editorState, _draftJs.Modifier.mergeBlockData(content, target, (0, _defineProperty2["default"])({}, ALIGNMENT_DATA_KEY, alignmentToSet)), "change-block-data");
  },
  splitBlock: function splitBlock(editorState) {
    var contentState = _draftJs.Modifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection()),
        splitState = _draftJs.EditorState.push(editorState, contentState, "split-block"),
        _getCurrentlySelected2 = (0, _getCurrentlySelectedBlock["default"])(editorState),
        currentBlock = _getCurrentlySelected2.currentBlock,
        alignment = currentBlock.getData().get(ALIGNMENT_DATA_KEY);

    return alignment ? ExtendedRichUtils.toggleAlignment(splitState, alignment) : splitState;
  }
}),
    _default = ExtendedRichUtils;
exports["default"] = _default;